import $ from 'jquery';
import BlockExporter from 'lib/export';
import EF from 'ef/ef';
import ExporterTemplate from 'views/exporter/templates/exporter';
import View from 'views/base/view';

const ExporterView = View.extend({
  autoRender: true,
  autoAttach: true,
  template: ExporterTemplate,
  noWrap: true,
  listen: {
    addedToDOM: 'loaded',
  },
  loaded: function () {
    this.$exporter = $('#course-exporter');
    this.blockExporter  = new BlockExporter();
    this.setListeners();
  },
  setListeners: function () {
    this.$exporter.find('#exportBtn').click(evt => {
      const exportLevel = this.$exporter.find('#exportLevel').val();
      const [m, a, p] = [
        EF.module.currentActivity.attributes.moduleKey,
        EF.module.currentActivity.attributes.key,
        EF.module.currentActivity.currentPage?.id,
      ];
      this.blockExporter.exportBlocks(exportLevel === 'page' ? `${m}.${a}.${p}` : exportLevel, this);
    });
  }
});

export default ExporterView;
